export async function validateAllowedFile(file: File): Promise<string | null> {
	if (file.size < 1024) {
		return "The file appears to be empty or corrupted. Please upload a valid document.";
	}

	const buffer = await file.slice(0, 8).arrayBuffer();
	const bytes = new Uint8Array(buffer);

	// JPEG: FF D8 FF
	if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return null;
	// PNG: 89 50 4E 47 0D 0A 1A 0A
	if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) return null;
	// PDF: 25 50 44 46 (%PDF)
	if (bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) return null;

	return "Only JPEG, PNG, and PDF files are supported.";
}
